import { Button, dialog, InputFactory } from "nq-component";
import {
  findObjectUseCase,
  upsertUseCase,
} from "../../../../../usecases/object";
import { createNotification } from "../../../../../createNotification";
import BaseFormPresenter from "../../../../../components/common/BaseFormPresenter";
import {
  CreditsDeduction,
  ServiceRecordLeave,
} from "../../../../../components/common/Converter";
import {
  getAllDatesFromRanges,
  buildDateConditions,
} from "../../../../../helper";

class HrddForApprovalFormPresenter extends BaseFormPresenter {
  onChangeObject(object) {
    this.change = object;
    this.object = object;
  }

  getDurationFormula(startdate, enddate) {
    const startDate = new Date(startdate);
    const endDate = new Date(enddate);

    // Calculate the difference in milliseconds
    const differenceInMs = endDate - startDate + 1;

    if (differenceInMs) {
      // Convert milliseconds to days
      const differenceInDays =
        Math.floor(differenceInMs / (1000 * 60 * 60 * 24)) + 1;

      return `${differenceInDays} Day/s`;
    } else {
      return "";
    }
  }

  // leaveWithoutPayDeduction(remainingCredits, lengthCount, startCycle) {
  //   const standardDeduction = 0.021;
  //   const specialDeductions = {
  //     2: 0.02,
  //     8: 0.02,
  //     14: 0.02,
  //     20: 0.02,
  //     27: 0.02,
  //     33: 0.02,
  //     39: 0.02,
  //     45: 0.02,
  //     51: 0.02,
  //     57: 0.02,
  //   };

  //   for (let day = startCycle; day < startCycle + lengthCount; day++) {
  //     // Calculate the equivalent day within a 1–60 range
  //     let cycleDay = ((day - 1) % 30) + 1;

  //     // Apply deduction based on the cycle day
  //     if (specialDeductions[cycleDay]) {
  //       remainingCredits -= specialDeductions[cycleDay]; // Apply special rate
  //     } else {
  //       remainingCredits -= standardDeduction; // Apply standard rate
  //     }
  //   }
  //   return remainingCredits.toFixed(3); // Return final remaining credits, rounded to 3 decimal places
  // }

  DialogConfirmation(status) {
    let result = "";
    dialog.fire({
      html: (
        <div className="p-2">
          <form
            onSubmit={(e) => {
              e.preventDefault();
              this.submitData(status, result);
            }}
          >
            <div className="row">
              <h4>{status}</h4>
              <hr />
              {status === "Disapproved" && (
                <div>
                  <label className="mb-2 fs-6">
                    Remarks <span className="text-danger">*</span>
                  </label>
                  <InputFactory
                    required={true}
                    type="Text"
                    onChange={(e) => (result = e)}
                  />
                </div>
              )}
              <p style={{ fontSize: "13px", padding: "1rem" }}>
                Click Confirm to continue!
              </p>
              <hr />
            </div>
            <div className="w-100 d-flex justify-content-end gap-4 pe-3 pb-3">
              <Button
                className="btn btn-light fs-sm"
                type="button"
                onClick={() => dialog.close()}
              >
                Cancel
              </Button>
              <Button className="btn btn-primary" type="submit">
                Confirm
              </Button>
            </div>
          </form>
        </div>
      ),
      footer: false,
    });
  }

  async submitData(status, result) {
    const { object } = this.view.getArgument();

    const { stats, category, employee, leaveType, acl, duration, ...rest } =
      this.view.state.object;
    const approveDuration = this.getDurationFormula(
      this.view.state.object.startdate,
      this.view.state.object.enddate,
    );

    const submitData = {
      stats: status,
      hrddRemarks: result,
      selectedType: leaveType.name,
      id: this.view.getObjectId(),
      duration: approveDuration,
      employee: { id: employee.id },
      leaveType: { id: leaveType.id },
      ...rest,
    };

    const allAvailableCredit = await findObjectUseCase().execute("leave_cred", {
      where: {
        empID: submitData.employee.id,
        // type: submitData.leaveType.name,
      },
    });

    const currentCredits = allAvailableCredit.filter(
      (item) => item.type === leaveType.name,
    );

    const isDeductible = leaveType.is_deductable;

    // if (!isDeductible) {
    //   if (status === "Approved") {
    //     const startDate = submitData?.startdate
    //       ? new Date(submitData.startdate)
    //       : new Date();
    //     const endDate = new Date(submitData.enddate);
    //     endDate.setDate(endDate.getDate() + 1);
    //     const serviceReq = await findObjectUseCase().execute("service_record", {
    //       where: {
    //         employee: { id: submitData.employee.id },
    //         from: {
    //           $gte: startDate,
    //           $lt: endDate,
    //         },
    //       },
    //     });
    //     if (serviceReq.length > 0) {
    //       serviceReq.forEach(async (item) => {
    //         const abbreviation = submitData.selectedType
    //           .split(" ") // Split the string into an array of words
    //           .map((word) => word.charAt(0)) // Take the first letter of each word
    //           .join(""); // Join them back together

    //         item.leave.push(
    //           ServiceRecordLeave(
    //             abbreviation,
    //             startDate,
    //             new Date(submitData.enddate)
    //           )
    //         );
    //         await upsertUseCase().execute("service_record", item);
    //       });
    //     }
    //   }
    //   await upsertUseCase().execute("leave_request", submitData);
    //   dialog.close();
    //   this.showSuccess(status);
    //   return;
    // }

    const hasVacationLeave = allAvailableCredit.some(
      (item) => item.type === "Vacation Leave",
    );

    if (status === "Approved") {
      const startDate = submitData?.startdate
        ? new Date(submitData.startdate)
        : new Date();
      const endDate = new Date(submitData.enddate);
      endDate.setDate(endDate.getDate() + 1);

      const withoutPayDates = object?.withoutPayDateRange
        ? getAllDatesFromRanges(object?.withoutPayDateRange)
        : [];
      const dateConditions = buildDateConditions(withoutPayDates);

      const dtrWhereClause = {
        "employee.id": object.employee.id,
      };

      if (dateConditions.length > 0) {
        dtrWhereClause.$or = dateConditions;
      }

      const serviceReq = await findObjectUseCase().execute("service_record", {
        where: {
          employee: { id: submitData.employee.id },
          from: {
            $gte: startDate,
            $lt: endDate,
          },
        },
      });

      // console.log("hasVacationLeave: ", dtrRecord);
      // return;

      if (serviceReq.length > 0) {
        serviceReq.forEach(async (item) => {
          const abbreviation = submitData.selectedType
            .split(" ") // Split the string into an array of words
            .map((word) => word.charAt(0)) // Take the first letter of each word
            .join(""); // Join them back together

          item.leave.push(
            ServiceRecordLeave(
              abbreviation,
              startDate,
              new Date(submitData.enddate),
            ),
          );
          await upsertUseCase().execute("service_record", item);
        });
      }

      if (
        (submitData.selectedType === "Sick Leave" && !hasVacationLeave) ||
        submitData.selectedType === "Vacation Leave" ||
        submitData.selectedType === "Forced/Mandatory Leave"
      ) {
        this.GenerateLeaveCard(
          currentCredits[0],
          submitData,
          submitData?.creditDeduction,
        );
      }

      if (submitData.selectedType === "Sick Leave" && hasVacationLeave) {
        this.GenerateLeaveCard(
          currentCredits[0],
          submitData,
          submitData?.creditDeduction,
        );
        if (parseFloat(submitData?.vacationLeaveDeduction) !== 0) {
          const vacationLeave = allAvailableCredit.find(
            (item) => item.type === "Vacation Leave",
          );

          this.GenerateLeaveCard(
            vacationLeave,
            submitData,
            submitData?.vacationLeaveDeduction,
          );
        }
      }
      await upsertUseCase().execute("leave_request", submitData);

      //  CREATE NOTIFICATION
      const NOTIFICATION_MESSAGE = "Your Leave Request has been approved!";
      const NOTIFICATION_RECEIVER = [submitData.createdBy.id];
      const NOTIFICATION_REDIRECT = "lmanagement";

      createNotification(
        NOTIFICATION_MESSAGE,
        NOTIFICATION_RECEIVER,
        NOTIFICATION_REDIRECT,
      );

      dialog.close();
      this.showSuccess("Approved!");
      return;
    }

    // Disapproved
    const creditDeduct = parseFloat(submitData.creditDeduction) || 0;

    if (leaveType.name === "Compensatory Time-Off") {
      this.CTOOvertimerequestDeduction(
        creditDeduct,
        currentCredits,
        submitData,
      );
      return;
    }

    if (leaveType.name === "Sick Leave" && hasVacationLeave) {
      this.handleSickLeveWithVacationDeduct(
        submitData,
        creditDeduct,
        allAvailableCredit,
        status,
      );
      return;
    }

    if (leaveType.name === "Forced/Mandatory Leave") {
      this.handleForcedLeave(
        submitData,
        creditDeduct,
        allAvailableCredit,
        status,
      );
      return;
    }

    // const totalCurrentCred = currentCredits?.reduce((total, item) => {
    //   return total + parseFloat(item.current);
    // }, 0);

    if (currentCredits.length > 0) {
      const leaveCred = parseFloat(currentCredits[0].current) + creditDeduct;
      currentCredits[0].current = leaveCred.toFixed(3);
      await upsertUseCase().execute("leave_cred", currentCredits[0]);
      await upsertUseCase().execute("leave_request", submitData);

      //  CREATE NOTIFICATION
      const NOTIFICATION_MESSAGE = "Your Leave Request has been approved!";
      const NOTIFICATION_RECEIVER = [submitData.createdBy.id];
      const NOTIFICATION_REDIRECT = "lmanagement";

      createNotification(
        NOTIFICATION_MESSAGE,
        NOTIFICATION_RECEIVER,
        NOTIFICATION_REDIRECT,
      );
      dialog.close();
      this.showSuccess("Successfully Approved");
      return;
    } else {
      dialog.close();
      this.showError("Insufficient Credits");
    }
  }

  async CTOOvertimerequestDeduction(creditDeduct, currentCredits, submitData) {
    if (currentCredits.length === 0) {
      this.showError("Insufficient Credits");
      return;
    }
    const ctoCredit = currentCredits[0];
    const current = parseFloat(ctoCredit.current) + creditDeduct;
    ctoCredit.current = current.toFixed(3);
    await upsertUseCase().execute("leave_request", submitData);
    await upsertUseCase().execute("leave_cred", ctoCredit);
    dialog.close();
    this.showSuccess("Successfully Approved");
  }

  async handleForcedLeave(
    submitData,
    creditDeduct,
    allAvailableCredit,
    status,
  ) {
    const vacationLeave = allAvailableCredit.find(
      (item) => item.type === "Vacation Leave",
    );
    const forcedLeave = allAvailableCredit.find(
      (item) => item.type === "Forced/Mandatory Leave",
    );

    const creditsVacation = parseFloat(vacationLeave.current) + creditDeduct;
    let creditsForced = parseFloat(forcedLeave.current) + creditDeduct;
    if (creditDeduct > 5) {
      creditsForced = 5;
    }

    vacationLeave.current = creditsVacation.toFixed(3);
    forcedLeave.current = creditsForced.toFixed(3);

    try {
      await upsertUseCase().execute("leave_cred", vacationLeave);
      await upsertUseCase().execute("leave_cred", forcedLeave);
      await upsertUseCase().execute("leave_request", submitData);
      if (status !== "With Pay") {
        dialog.close();
      }
      this.showSuccess("Successfully Approved");
      return;
    } catch (e) {
      console.error("Error: ", e);
    }
  }

  async handleSickLeveWithVacationDeduct(
    submitData,
    creditDeduct,
    allAvailableCredit,
    status,
  ) {
    const vacationBackCred = parseFloat(submitData?.vacationLeaveDeduction);
    const sickBackCred = creditDeduct - vacationBackCred;

    const credit = CreditsDeduction(
      allAvailableCredit,
      vacationBackCred,
      sickBackCred,
      0,
    );

    submitData.vacationLeaveDeduction = credit.vacationLeaveDeduction;
    credit.updatedCredits.forEach(async (item) => {
      await upsertUseCase().execute("leave_cred", item);
    });
    await upsertUseCase().execute("leave_request", submitData);
    if (status !== "With Pay") {
      dialog.close();
    }
    this.showSuccess("Successfully Approved");
    return;
  }

  async GenerateLeaveCard(findLeaveType, submitData, deduction) {
    const generateLeaveCard = {
      employee: { id: findLeaveType?.empID },
      leaveType: findLeaveType?.type,
      withPay: deduction,
      balance: findLeaveType?.current,
      startDate: submitData?.startdate,
      endDate: submitData?.enddate,
      categoryType: submitData?.categoryType,
      status: "Approved",
    };
    // console.log("GENERATE: ", generateLeaveCard);
    // console.log("SUBMIT: ", submitData);
    try {
      await upsertUseCase().execute("leave_card", generateLeaveCard);
    } catch (e) {
      console.error("E: ", e);
    }
  }
}

export default HrddForApprovalFormPresenter;
